module.exports = __webpack_public_path__ + "static/media/admin-pic.4e3e5d17.png";